<template>
  <div>
      <table class="admin__table">
        <tr v-for="(testimonial, index) in testimonials" :key="index"
            draggable="true"
            @dragenter="cancelEvent"
            @dragover="cancelEvent"
            @dragstart="item__dragstart(index)"
            @drop.prevent="item__dropped(index)">
          <td>
            <svg viewBox="0 0 100 100" width="30" height="30" style="fill:#999; cursor:pointer;">
              <rect y="25"  width="100" height="4"></rect>
              <rect y="50" width="100" height="4"></rect>
              <rect y="75" width="100" height="4"></rect>
            </svg>
          </td>
          <td style="width: 60px;"><img :src="imageThumbUrl(testimonial.image)" style="display:block; width:100%;" /></td>
          <td>{{ testimonial.has_video ? "▶" : ""}}</td>
          <td>{{ testimonial.name }}</td>
          <td style="font-size:9px; font-style:italic;">{{ testimonial.testimonial }}</td>
          <td>{{ testimonial.updated_at.toDate().toLocaleString('en-GB', { year: 'numeric', month: 'numeric', day: 'numeric' }) }}</td>
          <td><router-link :to="{ path: `/admin/testimonials/${testimonial.document_id}` }" >Edit</router-link></td>
        </tr>
      </table>
  </div>
</template>

<script>
import Testimonial from "../../../models/Testimonial";

export default {
  data(){
    return{
      testimonials: [],
      current_drag_index: 0,
    }
  },
  async mounted(){
    this.testimonials = await Testimonial.allOrderedBy('position');
  },
  methods: {
    item__dragstart(index){
      this.current_drag_index = index;
    },
    async item__dropped(index){
      let item = this.testimonials[this.current_drag_index];
      this.testimonials.splice(this.current_drag_index, 1);
      this.testimonials.splice(index, 0, item);

      for(let [index, testimonial] of this.testimonials.entries()) {
        testimonial.position = index;
        await testimonial.save();
      }
    }
  }
}
</script>
